import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, watch, onUnmounted, computed, reactive } from "vue";
import { useRoute, useRouter } from "vue-router"
import { Toast } from "vant"
import { cheackQuery, pickQueryParam, nativeToLogin, ToBack } from "@/uitls/native";
import { useI18n } from "vue-i18n";
import { storeToRefs } from "pinia";
import { usePiniaState } from "@/store/userPinia";
import EventBus from "@/uitls/EventBus";
import Platform from "@/config/platform";
import {
   encryptionGuessOrderList
} from "@/api/php/me";


export default /*#__PURE__*/_defineComponent({
  name: 'PointGuessingRecord',
  setup(__props, { expose }) {
  expose();

const { t } = useI18n();
const router = useRouter();
const route = useRoute();
const showTopBar = ref(true);
const refreshing = ref(false);
const matches = ref([]);
const loading = ref(false);
const finished = ref(true);

onMounted(() => {
    getGuessListInfo();
});

const getGuessListInfo = async () =>{
    const res: any = await encryptionGuessOrderList();
    
    if(res.code == 200){
        matches.value = res.data;
    }else{
        Toast({message:res.msg, type:"fail"});
    }
}
const onRefresh = async() => {
    matches.value = [];
    await getGuessListInfo();
    refreshing.value = false;
}

const guessState = (item) =>{
    switch(item.guess_result) {
        case "success":
            return t("竞猜成功");
            break;
        case "fail":
            return t("竞猜失败");
            break;
        case "pending":
            return t("未开奖");
            break;
    }
}

const getMatchName = (item) =>{
    if(item.guess_result == 'pending'){
        return `${item.home_name} VS ${item.home_name}`;
    }else{
        return `${item.home_name} ${item.home_score}:${item.away_score} ${item.home_name}`;
    }
}
const guessScroe = (item) =>{
    
}

const __returned__ = { t, router, route, showTopBar, refreshing, matches, loading, finished, getGuessListInfo, onRefresh, guessState, getMatchName, guessScroe, ToBack }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})